import { buildModelManager } from "../builder.js";
const DefaultShopifyShopSelection = {
  __typename: true,
  id: true,
  state: true,
  address1: true,
  address2: true,
  alertEmails: true,
  alertType: true,
  betaFeatures: true,
  blockingActive: true,
  blockingReplaceCode: true,
  blockingReplaceCodeMetafieldId: true,
  checkoutApiSupported: true,
  city: true,
  confirmationUrl: true,
  cookieConsentLevel: true,
  country: true,
  countryCode: true,
  countryName: true,
  countyTaxes: true,
  couponExtensionLeakedCodeCount: true,
  createdAt: true,
  currency: true,
  currentlyLeakedCodeCount: true,
  customerAccountsV2: true,
  customerEmail: true,
  customerTagsBlocked: true,
  disabledWebhooks: true,
  discountFunctionId: true,
  domain: true,
  duplicateBlockingMode: true,
  eligibleForCardReaderGiveaway: true,
  eligibleForPayments: true,
  email: true,
  enabledPresentmentCurrencies: true,
  exclusionCodes: true,
  extensionBlockingMode: true,
  finances: true,
  forceSsl: true,
  googleAppsDomain: true,
  googleAppsLoginEnabled: true,
  grantedScopes: true,
  hasDiscounts: true,
  hasGiftCards: true,
  hasStorefront: true,
  highRiskCodeCurrencyMinimum: true,
  highRiskCodePercentageMinimum: true,
  highRiskLeakedCodeCount: true,
  ianaTimezone: true,
  inactiveLeakedCodeCount: true,
  initialScrapeStatus: true,
  installedCheckoutExtension: true,
  installedExtensionAnalytics: true,
  installedViaApiKey: true,
  latitude: true,
  longitude: true,
  marketingSmsContentEnabledAtCheckout: true,
  moneyFormat: true,
  moneyInEmailsFormat: true,
  moneyWithCurrencyFormat: true,
  moneyWithCurrencyInEmailsFormat: true,
  multiLocationEnabled: true,
  myshopifyDomain: true,
  name: true,
  onboardingSurvey: true,
  passwordEnabled: true,
  phone: true,
  planDisplayName: true,
  planName: true,
  preLaunchEnabled: true,
  primaryLocale: true,
  province: true,
  provinceCode: true,
  registeredWebhooks: true,
  renderJobId: true,
  requiresExtraPaymentsAgreement: true,
  scrapingMapping: true,
  setupRequired: true,
  shopOwner: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  source: true,
  subscriptionId: true,
  taxShipping: true,
  taxesIncluded: true,
  timezone: true,
  transactionalSmsDisabled: true,
  trialStartedAt: true,
  updatedAt: true,
  version: true,
  webPixelId: true,
  weightUnit: true,
  zipCode: true
};
const modelApiIdentifier = "shopifyShop";
const pluralModelApiIdentifier = "shopifyShops";
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
const ShopifyShopManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyShopSelection,
  [
    {
      type: "findOne",
      operationName: modelApiIdentifier,
      modelApiIdentifier,
      findByVariableName: "id",
      defaultSelection: DefaultShopifyShopSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: modelApiIdentifier,
      modelApiIdentifier,
      findByVariableName: "id",
      defaultSelection: DefaultShopifyShopSelection,
      namespace: null
    },
    {
      type: "findMany",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultShopifyShopSelection,
      namespace: null
    },
    {
      type: "findFirst",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultShopifyShopSelection,
      namespace: null
    },
    {
      type: "maybeFindFirst",
      operationName: pluralModelApiIdentifier,
      modelApiIdentifier,
      defaultSelection: DefaultShopifyShopSelection,
      namespace: null
    },
    {
      type: "findOne",
      operationName: pluralModelApiIdentifier,
      functionName: "findById",
      findByField: "id",
      findByVariableName: "id",
      modelApiIdentifier,
      defaultSelection: DefaultShopifyShopSelection,
      namespace: null
    },
    {
      type: "maybeFindOne",
      operationName: pluralModelApiIdentifier,
      functionName: "maybeFindById",
      findByField: "id",
      findByVariableName: "id",
      modelApiIdentifier,
      defaultSelection: DefaultShopifyShopSelection,
      namespace: null
    },
    {
      type: "action",
      operationName: "createShopifyShop",
      operationReturnType: "CreateShopifyShop",
      functionName: "create",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: false,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        shopifyShop: { required: false, type: "CreateShopifyShopInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkCreateShopifyShops",
      functionName: "bulkCreate",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: false,
      singleActionFunctionName: "create",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkCreateShopifyShopsInput!]" }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "updateShopifyShop",
      operationReturnType: "UpdateShopifyShop",
      functionName: "update",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        shopifyShop: { required: false, type: "UpdateShopifyShopInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkUpdateShopifyShops",
      functionName: "bulkUpdate",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "update",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkUpdateShopifyShopsInput!]" }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "cancelSubscriptionShopifyShop",
      operationReturnType: "CancelSubscriptionShopifyShop",
      functionName: "cancelSubscription",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        shopifyShop: { required: false, type: "CancelSubscriptionShopifyShopInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkCancelSubscriptionShopifyShops",
      functionName: "bulkCancelSubscription",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "cancelSubscription",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: {
          required: true,
          type: "[BulkCancelSubscriptionShopifyShopsInput!]"
        }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "generateTrackingReportShopifyShop",
      operationReturnType: "GenerateTrackingReportShopifyShop",
      functionName: "generateTrackingReport",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        startDate: { required: false, type: "String" },
        endDate: { required: false, type: "String" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: ["startDate", "endDate"],
      hasReturnType: true,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkGenerateTrackingReportShopifyShops",
      functionName: "bulkGenerateTrackingReport",
      isBulk: true,
      isDeleter: false,
      hasReturnType: true,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "generateTrackingReport",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: {
          required: true,
          type: "[BulkGenerateTrackingReportShopifyShopsInput!]"
        }
      },
      paramOnlyVariables: ["startDate", "endDate"],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "initialScrapeShopifyShop",
      operationReturnType: "InitialScrapeShopifyShop",
      functionName: "initialScrape",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: { id: { required: true, type: "GadgetID" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkInitialScrapeShopifyShops",
      functionName: "bulkInitialScrape",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "initialScrape",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: { ids: { required: true, type: "[GadgetID!]" } },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "pollInitialScrapeStatusShopifyShop",
      operationReturnType: "PollInitialScrapeStatusShopifyShop",
      functionName: "pollInitialScrapeStatus",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        attempt: { required: false, type: "Float" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: ["attempt"],
      hasReturnType: false,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkPollInitialScrapeStatusShopifyShops",
      functionName: "bulkPollInitialScrapeStatus",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "pollInitialScrapeStatus",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: {
          required: true,
          type: "[BulkPollInitialScrapeStatusShopifyShopsInput!]"
        }
      },
      paramOnlyVariables: ["attempt"],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "stubbedAction",
      operationName: "reinstallShopifyShop",
      functionName: "reinstall",
      errorMessage: "The action reinstall on model shopifyShop does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers",
      actionApiIdentifier: "reinstall",
      modelApiIdentifier,
      variables: {},
      reason: "MissingApiTrigger",
      dataPath: "shopifyShop.reinstall"
    },
    {
      type: "stubbedAction",
      operationName: "bulkReinstallShopifyShops",
      functionName: "bulkReinstall",
      errorMessage: "The action reinstall on model shopifyShop does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers",
      actionApiIdentifier: "reinstall",
      modelApiIdentifier,
      variables: {},
      reason: "MissingApiTrigger",
      dataPath: "shopifyShop.bulkReinstall"
    },
    {
      type: "action",
      operationName: "runOrdersBulkQueryFrom2024OctToSyncOrInstallDateShopifyShop",
      operationReturnType: "RunOrdersBulkQueryFrom2024OctToSyncOrInstallDateShopifyShop",
      functionName: "runOrdersBulkQueryFrom2024OctToSyncOrInstallDate",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: { id: { required: true, type: "GadgetID" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: true,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkRunOrdersBulkQueryFrom2024OctToSyncOrInstallDateShopifyShops",
      functionName: "bulkRunOrdersBulkQueryFrom2024OctToSyncOrInstallDate",
      isBulk: true,
      isDeleter: false,
      hasReturnType: true,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "runOrdersBulkQueryFrom2024OctToSyncOrInstallDate",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: { ids: { required: true, type: "[GadgetID!]" } },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "runOrdersBulkQueryFrom60DaysAgoToNowShopifyShop",
      operationReturnType: "RunOrdersBulkQueryFrom60DaysAgoToNowShopifyShop",
      functionName: "runOrdersBulkQueryFrom60DaysAgoToNow",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: { id: { required: true, type: "GadgetID" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: true,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkRunOrdersBulkQueryFrom60DaysAgoToNowShopifyShops",
      functionName: "bulkRunOrdersBulkQueryFrom60DaysAgoToNow",
      isBulk: true,
      isDeleter: false,
      hasReturnType: true,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "runOrdersBulkQueryFrom60DaysAgoToNow",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: { ids: { required: true, type: "[GadgetID!]" } },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "sendFeedbackShopifyShop",
      operationReturnType: "SendFeedbackShopifyShop",
      functionName: "sendFeedback",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        feedback: { required: false, type: "String" },
        userEmail: { required: false, type: "String" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: ["feedback", "userEmail"],
      hasReturnType: true,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkSendFeedbackShopifyShops",
      functionName: "bulkSendFeedback",
      isBulk: true,
      isDeleter: false,
      hasReturnType: true,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "sendFeedback",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkSendFeedbackShopifyShopsInput!]" }
      },
      paramOnlyVariables: ["feedback", "userEmail"],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "sendInstallEmailShopifyShop",
      operationReturnType: "SendInstallEmailShopifyShop",
      functionName: "sendInstallEmail",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        shopifyShop: { required: false, type: "SendInstallEmailShopifyShopInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkSendInstallEmailShopifyShops",
      functionName: "bulkSendInstallEmail",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "sendInstallEmail",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: {
          required: true,
          type: "[BulkSendInstallEmailShopifyShopsInput!]"
        }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "sendSetupReminderShopifyShop",
      operationReturnType: "SendSetupReminderShopifyShop",
      functionName: "sendSetupReminder",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: { id: { required: true, type: "GadgetID" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkSendSetupReminderShopifyShops",
      functionName: "bulkSendSetupReminder",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "sendSetupReminder",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: { ids: { required: true, type: "[GadgetID!]" } },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "sendUninstallEmailShopifyShop",
      operationReturnType: "SendUninstallEmailShopifyShop",
      functionName: "sendUninstallEmail",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: { id: { required: true, type: "GadgetID" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkSendUninstallEmailShopifyShops",
      functionName: "bulkSendUninstallEmail",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "sendUninstallEmail",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: { ids: { required: true, type: "[GadgetID!]" } },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "submitOnboardingSurveyShopifyShop",
      operationReturnType: "SubmitOnboardingSurveyShopifyShop",
      functionName: "submitOnboardingSurvey",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        shopifyShop: {
          required: false,
          type: "SubmitOnboardingSurveyShopifyShopInput"
        }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: false,
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkSubmitOnboardingSurveyShopifyShops",
      functionName: "bulkSubmitOnboardingSurvey",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "submitOnboardingSurvey",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: {
          required: true,
          type: "[BulkSubmitOnboardingSurveyShopifyShopsInput!]"
        }
      },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "subscribeShopifyShop",
      operationReturnType: "SubscribeShopifyShop",
      functionName: "subscribe",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        id: { required: true, type: "GadgetID" },
        planId: { required: false, type: "Float" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: ["planId"],
      hasReturnType: false,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkSubscribeShopifyShops",
      functionName: "bulkSubscribe",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "subscribe",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkSubscribeShopifyShopsInput!]" }
      },
      paramOnlyVariables: ["planId"],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "stubbedAction",
      operationName: "uninstallShopifyShop",
      functionName: "uninstall",
      errorMessage: "The action uninstall on model shopifyShop does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers",
      actionApiIdentifier: "uninstall",
      modelApiIdentifier,
      variables: {},
      reason: "MissingApiTrigger",
      dataPath: "shopifyShop.uninstall"
    },
    {
      type: "stubbedAction",
      operationName: "bulkUninstallShopifyShops",
      functionName: "bulkUninstall",
      errorMessage: "The action uninstall on model shopifyShop does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers",
      actionApiIdentifier: "uninstall",
      modelApiIdentifier,
      variables: {},
      reason: "MissingApiTrigger",
      dataPath: "shopifyShop.bulkUninstall"
    },
    {
      type: "action",
      operationName: "verifyThemeAppExtensionIsActiveShopifyShop",
      operationReturnType: "VerifyThemeAppExtensionIsActiveShopifyShop",
      functionName: "verifyThemeAppExtensionIsActive",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: true,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: { id: { required: true, type: "GadgetID" } },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: [],
      hasReturnType: true,
      acceptsModelInput: false,
      hasCreateOrUpdateEffect: false,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkVerifyThemeAppExtensionIsActiveShopifyShops",
      functionName: "bulkVerifyThemeAppExtensionIsActive",
      isBulk: true,
      isDeleter: false,
      hasReturnType: true,
      acceptsModelInput: false,
      operatesWithRecordIdentity: true,
      singleActionFunctionName: "verifyThemeAppExtensionIsActive",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: { ids: { required: true, type: "[GadgetID!]" } },
      paramOnlyVariables: [],
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "upsertShopifyShop",
      operationReturnType: "UpsertShopifyShop",
      functionName: "upsert",
      namespace: null,
      modelApiIdentifier,
      operatesWithRecordIdentity: false,
      modelSelectionField: modelApiIdentifier,
      isBulk: false,
      isDeleter: false,
      variables: {
        on: { required: false, type: "[String!]" },
        shopifyShop: { required: false, type: "UpsertShopifyShopInput" }
      },
      hasAmbiguousIdentifier: false,
      paramOnlyVariables: ["on"],
      hasReturnType: {
        "... on CreateShopifyShopResult": { hasReturnType: false },
        "... on UpdateShopifyShopResult": { hasReturnType: false }
      },
      acceptsModelInput: true,
      hasCreateOrUpdateEffect: true,
      defaultSelection: DefaultShopifyShopSelection
    },
    {
      type: "action",
      operationName: "bulkUpsertShopifyShops",
      functionName: "bulkUpsert",
      isBulk: true,
      isDeleter: false,
      hasReturnType: false,
      acceptsModelInput: true,
      operatesWithRecordIdentity: false,
      singleActionFunctionName: "upsert",
      modelApiIdentifier,
      modelSelectionField: pluralModelApiIdentifier,
      namespace: null,
      variables: {
        inputs: { required: true, type: "[BulkUpsertShopifyShopsInput!]" }
      },
      paramOnlyVariables: ["on"],
      defaultSelection: DefaultShopifyShopSelection
    }
  ]
);
export {
  DefaultShopifyShopSelection,
  ShopifyShopManager
};
//# sourceMappingURL=ShopifyShop.js.map
